import { useState } from "react";
import { motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../data/content";

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq-section" className="bg-[#EFECE4] py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <p className="uppercase text-xs tracking-[0.25em] text-[#C4A575] font-semibold">
            Good to Know
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-primary mt-4 leading-tight">
            Questions, answered
          </h2>
        </div>

        <div className="divide-y divide-border/60 border-y border-border/60">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="font-serif text-xl md:text-2xl text-primary">
                    {f.q}
                  </span>
                  {isOpen ? (
                    <Minus size={20} className="text-[#C4A575] shrink-0" />
                  ) : (
                    <Plus size={20} className="text-[#C4A575] shrink-0" />
                  )}
                </button>
                <motion.div
                  initial={false}
                  animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
                  transition={{ duration: 0.35 }}
                  className="overflow-hidden"
                >
                  <p className="pb-6 text-text-muted leading-relaxed" style={{ color: "#5A655E" }}>
                    {f.a}
                  </p>
                </motion.div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
